import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

// `allow` es un predicado opcional sobre el usuario (para permisos que no son
// un rol, como el técnico jefe de zona). Si devuelve true, entra aunque su rol
// no esté en `rolesAllowed`.
export default function ProtectedRoute({ children, rolesAllowed, allow }) {
  const { user, loading } = useAuth()

  if (loading) return null
  if (!user) return <Navigate to="/login" replace />
  if (typeof allow === 'function' && allow(user)) return children
  if (!rolesAllowed || rolesAllowed.length === 0) return children

  const norm = (r) => String(r || '').trim().toLowerCase()
  const userRoles = Array.isArray(user.roles)
    ? user.roles.map(norm)
    : user.role
      ? [norm(user.role)]
      : []
  const allowed = rolesAllowed.map(norm)

  if (!userRoles.some((r) => allowed.includes(r))) {
    return <Navigate to="/unauthorized" replace />
  }

  return children
}
